import { clearBit } from "../../../helpers/binary-helpers.js";
export function getResSubOperations(cpu) {
    const { registers, memory } = cpu;
    // ****************
    // * Res b, A
    // ****************
    function getResBAByteDefinition(bitPosition, registerCode) {
        return (0b10 << 6) + (bitPosition << 3) + registerCode;
    }
    cpu.registers.baseRegisters.forEach(register => {
        for (let bitPosition = 0; bitPosition < 8; bitPosition++) {
            cpu.addCbOperation({
                byteDefinition: getResBAByteDefinition(bitPosition, register.code),
                instruction: `RES ${bitPosition}, ${register.name}`,
                cycleTime: 8,
                byteLength: 2,
                execute() {
                    register.value = clearBit(register.value, bitPosition);
                }
            });
        }
    });
    // ****************
    // * Res b, (HL)
    // ****************
    function getResHLByteDefinition(bitPosition) {
        return (0b10 << 6) + (bitPosition << 3) + 0b110;
    }
    for (let bitPosition = 0; bitPosition < 8; bitPosition++) {
        cpu.addCbOperation({
            byteDefinition: getResHLByteDefinition(bitPosition),
            instruction: `RES ${bitPosition}, (HL)`,
            cycleTime: 12,
            byteLength: 2,
            execute() {
                const value = memory.readByte(registers.HL.value);
                const bitSet = clearBit(value, bitPosition);
                memory.writeByte(registers.HL.value, bitSet);
            }
        });
    }
}
//# sourceMappingURL=res-operations.js.map